function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96.8838 114.526L162.559 101.152L235.25 112.138L178.012 126.547L96.8848 114.526H96.8838Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M161.534 101.152L163.426 186.97L226.656 197.876L234.225 112.138L161.534 101.152Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M178.011 216.823L106.424 200.025L96.8848 114.526L178.011 126.547V216.823Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M135.28 206.871L126.056 119.461L141.587 121.771L148.052 209.897L135.28 206.871Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M178.012 126.547L235.251 112.138L227.682 197.876L178.012 216.823V126.547Z",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M195.436 210.375L207.656 205.758L217.274 117.074L204.739 120.337L195.436 210.375Z",
  fill: "url(#paint5_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M239.424 74.6155L184.296 91.5386L184.073 110.956L237.385 92.6443L239.424 74.6155Z",
  fill: "url(#paint6_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M239.424 74.6156L183.253 67.1216L164.498 64.7013L91.7598 82.373L184.296 91.5387L239.424 74.6156Z",
  fill: "url(#paint7_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M94.7659 99.7802L184.073 110.956L184.296 91.5386L91.7598 82.3728L94.7659 99.7792V99.7802Z",
  fill: "url(#paint8_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M114.027 84.5482L132.644 86.6427L135.515 104.914L118.965 102.797L114.027 84.5482Z",
  fill: "#EBB02A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M114.028 84.5482L183.254 67.1226L198.928 69.2615L132.645 86.6426L114.028 84.5482Z",
  fill: "#F2BB4E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M211.358 83.4806L209.024 102.362L220.967 98.3072L223.454 79.5157L211.358 83.4806Z",
  fill: "#EBB02A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M223.454 79.5157L140.929 70.3721L127.281 73.759L211.358 83.4806L223.454 79.5157Z",
  fill: "#F2BB4E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M114.707 46.9992C114.707 46.9992 134.181 72.7057 159.446 75.236C165.342 74.9878 168.144 73.427 168.144 73.427L133.041 47.3301C135.373 39.5516 139.793 32.6245 145.937 27.3178C148.464 25.1043 146.188 20.989 142.941 22.0453L132.146 25.5401L120.796 35.1851L114.707 46.9992Z",
  fill: "#E89A24"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M165.422 74.9929L147.244 36.6037C146.9 35.7875 146.139 35.2619 145.279 35.047C142.694 34.481 136.706 33.691 129.4 36.066C119.417 39.2984 114.708 46.9993 114.708 46.9993L120.711 35.2589C122.44 31.8821 124.776 28.9432 127.708 26.5975C133.084 22.112 139.618 19.3679 146.579 18.6354L152.822 17.9352C155.385 17.6275 157.82 19.2942 158.448 21.8729L171.106 71.8765L165.422 74.9939V74.9929Z",
  fill: "#F2BB4E"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M219.315 42.761C219.315 42.761 202.062 69.9425 177.056 74.4876C171.159 74.7358 168.224 73.4323 168.224 73.4323L201.081 44.5781C198.153 37.0104 193.092 30.492 186.568 25.7017C183.837 23.6981 185.864 19.3891 189.152 20.1609L200.112 22.7033L212.335 31.516L219.315 42.761Z",
  fill: "#E89A24"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M171.079 74.7306L186.044 35.0258C186.337 34.1723 187.011 33.5821 187.902 33.3228C190.416 32.5358 196.294 31.3353 203.809 33.0978C213.983 35.511 219.236 42.7559 219.236 42.7559L212.255 31.5108C210.239 28.2854 207.633 25.5765 204.595 23.3943C198.891 19.4516 192.124 17.1826 185.146 16.9626L178.88 16.7901C176.264 16.6973 173.994 18.6101 173.594 21.1223L165.141 71.9602L171.079 74.7306Z",
  fill: "#F2BB4E"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 79.4107,
  y1: 108.074,
  x2: 160.104,
  y2: 198.629,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 152.355,
  y1: 127.518,
  x2: 245.892,
  y2: 141.996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 86.64,
  y1: 142.411,
  x2: 190.756,
  y2: 159.417,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 133.815,
  y1: 255.335,
  x2: 224.294,
  y2: 205.573,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D79173"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.886,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 170.784,
  y1: 140.674,
  x2: 245.258,
  y2: 149.061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 203.14,
  y1: 257.253,
  x2: 294.538,
  y2: 208.878,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D79173"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.886,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 177.083,
  y1: 84.5215,
  x2: 243.48,
  y2: 105.351,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 73.1125,
  y1: 72.017,
  x2: 158.291,
  y2: 168.543,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 80.0742,
  y1: 90.1643,
  x2: 164.475,
  y2: 146.442,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})));

function SvgImgOffer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 227,
    viewBox: "0 0 332 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOffer2);
export default __webpack_public_path__ + "static/media/img-offer-2.1f9f1fe9.svg";
export { ForwardRef as ReactComponent };